export default ({ $axios, app, $config, store, error, $router }, inject) => {
  inject('auth', {
    name: 'auth',
    async initialLogin() {
      if (this.checkCookie()) {
        try {
          this.setAxiosHeader(app.$cookies.get('auth'));
          if (app.$cookies.get('isGuest')) {
            this.setAuthData(this.guestData());
          } else {
            const { data } = await this.getCurrentUser();
            this.setAuthData(data);
            if (data.user.roleId === 0) {
              app.$cookies.set('isGuest', '1', {
                path: '/',
                maxAge: 60 * 60 * 24 * 365 * 10,
              });
            }
          }
        } catch {
          try {
            await this.guestLogin();
            app.router.push(app.localePath({ name: 'login' }));
          } catch {
            error({ statusCode: 500, message: 'Login error' });
          }
        }
      } else {
        try {
          await this.guestLogin();
        } catch {
          error({ statusCode: 500, message: 'Login error' });
        }
      }
    },
    async login(user, password, isRemember = false, oldToken = null) {
      const { data } = await $axios.post(`${$config.baseOfixApi}/oauth2/token`, {
        grant_type: 'password',
        username: user,
        password,
        ofix_remember_me: isRemember,
        client_id: $config.apiClientId,
        client_secret: $config.apiClientSecret,
        ...(oldToken && { ofix_guest_token: oldToken }),
      });

      if (data.ofix_frontend_version === 1 && data.ofix_redirect_url) {
        this.setFrontendVersionCookie(data.ofix_frontend_version, 2678400);
        window.location.replace(data.ofix_redirect_url);
        throw new Error('redirect');
      }

      this.setCookie(`${data.token_type} ${data.access_token}`, data.expires_in);
      this.setAxiosHeader(`${data.token_type} ${data.access_token}`);
      if (data.ofix_is_guest) {
        this.setAuthData({
          roleId: 0,
          roleName: 'brak dostępu',
        });
      } else {
        const response = await this.getCurrentUser();
        this.setAuthData(response.data);
        if (window) {
          const channel = new BroadcastChannel('ofix-app');
          channel.postMessage({ type: 'LOGIN' });
        }
      }
    },
    async guestLogin() {
      app.$axios.setToken(false);
      await this.login('guest', 'guest');
      app.$cookies.set('isGuest', '1', {
        path: '/',
        maxAge: 60 * 60 * 24 * 365 * 10,
      });
      this.setAuthData(this.guestData());
    },
    async logout() {
      store.commit('layout/setLoader', true);
      app.$cache.reset();
      this.clearAuthData();
      app.$cookies.set('isGuest', '1', {
        path: '/',
        maxAge: 60 * 60 * 24 * 365 * 10,
      });
      app.$cookies.remove('auth');
      store.commit('cart/setCart', null);
      store.commit('costCenters/setCostCenters', []);
      store.dispatch('layout/resetState');
      store.dispatch('settings/resetState');
      await this.initialLogin().then(() => {
        app.router.push(app.localePath({ name: 'login' }));
      });

      if (store.state.cart.editOrderId) {
        store.commit('cart/setOrderCart', null);
        store.commit('cart/setEditOrderId', null);
        localStorage.removeItem('orderEditId');
      }

      if (window) {
        setTimeout(() => window.location.reload(), 1);
        const channel = new BroadcastChannel('ofix-app');
        channel.postMessage({ type: 'LOGOUT' });
      }
    },
    checkCookie() {
      if (app.$cookies.get('auth')) {
        this.setAxiosHeader(app.$cookies.get('auth'));
        return true;
      } else {
        return false;
      }
    },
    setCookie(token, expiresIn) {
      const options = {
        path: '/',
        maxAge: expiresIn,
        ...($config.https === 'true' && { secure: true }),
      };
      app.$cookies.set('auth', token, options);
    },
    setFrontendVersionCookie(token, expiresIn) {
      const options = {
        path: '/',
        maxAge: expiresIn,
      };
      app.$cookies.set('frontendVersion', token, options);
    },
    setAxiosHeader(token) {
      if (token) $axios.setToken(token);
    },
    getCurrentUser() {
      return $axios.get(
        `${$config.baseOfixApi}/e-commerce/v1/users/current?includeCustomerServicePerson=true&includeAcl=true&includeDefaultCostCenter=true`,
      );
    },
    setAuthData(data) {
      store.commit('auth/setUser', data.user);
      if (data.company && data.company.id) {
        store.commit('auth/setCompany', data.company);
      }
      if (data.customerServicePerson) {
        store.commit('auth/setService', data.customerServicePerson);
      }
      if (data.acl) {
        store.commit('auth/setAcl', data.acl);
      }

      if (data.minimumValueLimitation) {
        store.commit('auth/setMinimumValueLimitation', data.minimumValueLimitation);
      }
    },
    clearAuthData() {
      store.commit('auth/setUser', null);
      store.commit('auth/setCompany', null);
      store.commit('auth/setService', null);
      store.commit('auth/setAcl', null);
    },
    setGoToBasket(param) {
      store.commit('auth/setGoToBasket', param);
    },
    guestData() {
      return {
        pathFrom: null,
        goToBasket: false,
        user: {
          roleName: 'brak dostępu',
          firstName: '',
          lastName: '',
          id: null,
          companyId: null,
          phone1: '+48',
          phoneCell: null,
          email: null,
          login: null,
          roleId: 0,
        },
        company: null,
        service: null,
        acl: null,
      };
    },
    setPathFrom(url) {
      store.commit('auth/setPathFrom', url);
    },
    isLogged() {
      return store.getters['auth/isLogged'];
    },
    isOnlyUser() {
      return store.getters['auth/isOnlyUser'];
    },
    getStoreUser() {
      return store.state.auth.user;
    },
    getStoreAcl() {
      return store.state.auth.acl;
    },
    getStoreCompany() {
      return store.state.auth.company;
    },
  });
};
